import { GreenCtaButton } from '../../components/atomic/buttons/green_cta_button/GreenCtaButton';
import textImg from '../texts/select_text.png';

type ButtonProps = {
  onClick?: () => void;
};

/** Select character CTA. */
export function Button({ onClick }: ButtonProps) {
  return (
    <GreenCtaButton
      textSrc={textImg}
      ariaLabel="Выбрать"
      onClick={onClick}
      left={296}
      top={1682.42578125}
      width={547.19140625}
      gradient={{ sizeX: 460.08, sizeY: 977.58, atX: 273.6, atY: 86.5 }}
      flash={{ left: 548.101, top: 35.876 }}
      textSize={{ width: 263.053, height: 90 }}
    />
  );
}
